import script from "./PaymentConceptsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentConceptsSelector.vue?vue&type=script&setup=true&lang=js"

import "./PaymentConceptsSelector.vue?vue&type=style&index=0&id=49b0f690&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b0f690"]])

export default __exports__